import 'ui-theme/widgets/publication-content/js/publication-content';

UX.loader.truncation.showMoreText = 'see more';
UX.loader.truncation.showLessText = 'see less';
UX.loader.truncation.seeMoreIcon = 'icon-section_arrow_d';
UX.loader.truncation.seeLessIcon = 'icon-section_arrow_u';
UX.loader.truncation.seeMoreIconMobile = 'icon-arrow_r';
UX.loader.truncation.linesToShow = 2;

function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

function handleAuthorHover(e) {
    const author = e.target.closest('.author-name.accordion-tabbed__control[data-db-target-for]');
    if (author) {
        if (!author.classList.contains('js--open')) {
            author.click();
        }
    }
}

function handleAuthorLeave(e) {
    const parent = e.target.querySelector('.accordion-tabbed__tab.js--open');
    if (parent) {
        const author = parent.querySelector('.author-name.accordion-tabbed__control[data-db-target-for]');
        if (author && author.classList.contains('js--open')) {
            author.click();
        }
    }
}

let authorsWrapper = document.querySelector('.citation .loa-wrapper .loa-accordion');

authorsWrapper?.addEventListener(
    'mouseover',
    debounce(function (e) {
        handleAuthorHover(e);
    }, 100)
);
authorsWrapper?.addEventListener(
    'mouseleave',
    debounce(function (e) {
        handleAuthorLeave(e);
    }, 100)
);
